import styled from "styled-components"

export const UserIcon = styled.img `

    width: 55px;
    height: auto;

`